'use client';

import { SessionData } from '@auth0/nextjs-auth0/types';
import ExperienceNav from 'components/ExperienceNav';
import MarketingNav from 'components/app/header/MarketingNav';
import { usePathname } from 'next/navigation';
import { ReactElement } from 'react';

const MARKETING_PATH_PREFIXES = [
  '/about-us',
  '/new-to-medicare',
  '/medicare-university',
  '/resources',
  '/lbry/',
];

export default function MainNav({
  draftModeEnabled,
  previewEnabled,
  session,
  isAdmin = false,
}: {
  draftModeEnabled: boolean;
  previewEnabled: boolean;
  session: null | SessionData;
  isAdmin?: boolean;
}): ReactElement {
  const pathname = usePathname();

  const isOnMarketingPage =
    pathname === '/' ||
    MARKETING_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));

  return isOnMarketingPage ? (
    <MarketingNav session={session} isAdmin={isAdmin} />
  ) : (
    <ExperienceNav
      draftModeEnabled={draftModeEnabled}
      previewEnabled={previewEnabled}
      session={session}
      isAdmin={isAdmin}
    />
  );
}
